export default {
  title: "Remoção dos horários de partida e informações para todas as linhas municipais",
  resume: "Optamos por remover de nossa plataforma todos os horários de partidas e informações referentes às linhas operadas pela Vinscol",
  img: "/news/neobus-M28.png",
  publishDate: "2026-06-10T00:00:00-03:00",
  // fixed: true,
  content: [
    "Devido ao descumprimento dos horários divulgados, à redução das viagens realizadas e à insuficiência de informações confiáveis sobre os horários de partida das linhas municipais, optamos por remover de nossa plataforma todos os horários de partidas referentes às linhas operadas pela Vinscol.",
    "Mas saiba que: se no futuro, a operadora ou a Prefeitura divulgar informações confiáveis e verdadeiras sobre os horários de partida das linhas municipais, atualizaremos a nossa plataforma e informaremos o nosso público."
  ],
};
